import { FaqSection } from '@saatva-bits/pattern-library.modules.faq'

import Layout from '@/layouts/Default'
import AffirmHeader from './partials/AffirmHeader/AffirmHeader'
import ChoosePayment from './partials/ChoosePayment/ChoosePayment'
import AccountFlow from './partials/AccountFlow/AccountFlow'
import Confidence from './partials/Confidence/Confidence'

export default function FinancingView(props) {
    return (
        <Layout {...props}>
            <AffirmHeader />
            <ChoosePayment />
            <AccountFlow />
            <Confidence />
            <FaqSection />
        </Layout>
    )
}
